interface TableOfContentsProps {
  scrollTo: (id: string) => void;
}

export default function TableOfContents({ scrollTo }: TableOfContentsProps) {
  const items = [
    { id: 'what-is', label: 'Что такое корпоративное обучение', icon: 'ri-information-line' },
    { id: 'why-need', label: 'Зачем оно нужно', icon: 'ri-question-line' },
    { id: 'statistics', label: 'Статистика и цифры', icon: 'ri-bar-chart-line' },
    { id: 'comparison', label: 'Внутреннее vs Внешнее обучение', icon: 'ri-scales-line' },
    { id: 'types', label: 'Виды обучения', icon: 'ri-stack-line' },
    { id: 'formats', label: 'Форматы', icon: 'ri-layout-grid-line' },
    { id: 'tasks', label: 'Частые задачи компаний', icon: 'ri-task-line' },
    { id: 'process', label: 'Этапы внедрения', icon: 'ri-route-line' },
    { id: 'trainer', label: 'Почему внешний тренер', icon: 'ri-user-star-line' },
    { id: 'methods', label: 'Методы и оценка эффективности', icon: 'ri-line-chart-line' },
    { id: 'mistakes', label: 'Ошибки компаний', icon: 'ri-error-warning-line' },
    { id: 'faq', label: 'FAQ', icon: 'ri-question-answer-line' },
  ];

  return (
    <section id="table-of-contents" className="py-14 md:py-20 bg-gray-50">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 text-center mb-3">
          Содержание
        </h2>
        <p className="text-sm text-gray-500 text-center mb-10">
          Быстрая навигация по странице — нажмите на раздел, чтобы перейти к нему
        </p>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
          {items.map((item, i) => (
            <button
              key={i}
              onClick={() => scrollTo(item.id)}
              className="flex items-center gap-3 bg-white p-4 rounded-xl hover:ring-2 hover:ring-teal-200 hover:bg-teal-50 transition-all text-left group cursor-pointer"
            >
              <div className="w-9 h-9 bg-teal-600 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform">
                <i className={`${item.icon} text-sm text-white`}></i>
              </div>
              <span className="text-sm font-medium text-gray-800 group-hover:text-teal-700 transition-colors leading-snug">
                {item.label}
              </span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}